export default __webpack_public_path__ + "static/designer-aleksandar-cucukovic-d7d42b9d24e0b49e4aab120eb6b6eaa2.png";